import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import EventPackageForm from './EventPackageForm'

const EventPackageCreate: React.FC = () => (
  <SectionWrapper title={'resources.eventpackages.createPackage'}>
    <Create>
      <EventPackageForm />
    </Create>
  </SectionWrapper>
)

export default EventPackageCreate
